// extracted by mini-css-extract-plugin
export default {"featuredClothingSection":"tsrlSYWs29TR0jHOvJQ8","featuredClothingTextBlock":"JaPm7_fwNIU3jtsn8j_l","featuredClothingTitle":"W7up7_Cz8q1FMxV2ag0A"};